import { useState } from 'react';
import { MainAdminLayout } from 'admin/layout/MainAdminLayout';
import { PackagesTopBlock } from 'admin/components/Packages/PackagesTopBlock';
import { MainTable } from 'admin/components/Table';
import { PackageViewModal } from 'admin/components/Packages/PackageViewModal';
import { PackageEditModal } from 'admin/components/Packages/PackageEditModal';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { PACKAGE_DATA, PACKAGES_HEADER } from 'admin/TableDatas/mockDatas';
import { ACTIVE_TABS, SHOW_CONTENT_NUMBERS } from 'admin/utils/contants';
import { SampleDiv } from 'admin/layout/styled';
import { ModalWrapper } from 'admin/components/Requsts/styled';
import { Images } from 'assets/images';
import {
  CheckedIcon,
  CloseIcon,
  KeepChanges,
  KeepChangesCheckbox,
  KeepChangesCheckboxWrapper,
  KeepChangesText,
  ModalContainer,
  SaveButton,
  SaveButtonWrapper,
} from 'admin/components/Packages/styled';

export const AdminPackages = () => {
  const [selected, setSelected] = useState(SHOW_CONTENT_NUMBERS[0].value);
  const [editData, setEditData] = useState([]);
  const [packageData, setPackageData] = useState(PACKAGE_DATA);
  const [selectedItems, setSelectedItems] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [isViewModal, setIsViewModal] = useState(true);
  const [viewModalData, setViewModalData] = useState([]);
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  const OpenEditModal = (rowData) => {
    setIsOpen(true);
    setEditData(rowData);
  };

  const closeEditModal = () => {
    setIsOpen(false);
  };

  const handleChecked = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleViewModal = () => {
    setIsViewModal((prev) => !prev);
  };

  return (
    <MainAdminLayout>
      {isViewModal ? (
        <>
          <PackagesTopBlock
            setSelected={setSelected}
            selected={selected}
            _data={packageData}
            setData={setPackageData}
            selectedItems={selectedItems}
          />
          {isOpen ? (
            <ModalContainer>
              <SampleDiv ref={ref}>
                <ModalWrapper isRelative>
                  <CloseIcon src={Images.closeBlueIcon} onClick={closeEditModal}/>
                  <PackageEditModal editData={editData} />
                  <SaveButtonWrapper>
                    <KeepChanges>
                      <KeepChangesText>Keep Changes</KeepChangesText>
                      <KeepChangesCheckboxWrapper>
                        <KeepChangesCheckbox
                          type="checkbox"
                          onChange={handleChecked}
                        />
                        {isChecked ? (
                          <CheckedIcon src={Images.doneIconMainColor} />
                        ) : null}
                      </KeepChangesCheckboxWrapper>
                    </KeepChanges>
                    <SaveButton>Save</SaveButton>
                  </SaveButtonWrapper>
                </ModalWrapper>
              </SampleDiv>
            </ModalContainer>
          ) : null}
          <MainTable
            OpenEditModal={OpenEditModal}
            headerData={PACKAGES_HEADER}
            _data={packageData}
            setDelete={setPackageData}
            selected={selected}
            activeTab={ACTIVE_TABS.PACKAGES}
            setSelectedItems={setSelectedItems}
            selectedItems={selectedItems}
            handleViewModal={handleViewModal}
            setViewModalData={setViewModalData}
          />
        </>
      ) : (
        <PackageViewModal
          viewModalData={viewModalData}
          handleViewModal={handleViewModal}
        />
      )}
    </MainAdminLayout>
  );
};
